if (!customElements.get("product-recommendations")){
  class ProductRecommendations extends HTMLElement {
    observer = undefined;

    constructor() {
      super();
      this.loading = false;
    }

    connectedCallback() {
      this.initializeRecommendations(this.dataset.productId);
    }

    initializeRecommendations(productId) {
      this.observer?.unobserve(this);
      this.observer = new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          this.loadRecommendations(productId);
        },
        { rootMargin: "0px 0px 2200px 0px" }
      );
      this.observer.observe(this);
    }

    loadRecommendations(productId) {
      if (this.loading || !productId) return;

      const requestUrl = `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`;
      const cacheKey = `product-recommendations:${requestUrl}`;
      const cachedHtml = this.getCachedHtml(cacheKey);

      if (cachedHtml) {
        this.applyRecommendations(cachedHtml);
        return;
      }

      this.loading = true;

      fetch(requestUrl, { credentials: "same-origin" })
        .then((response) => {
          if (!response.ok) throw new Error(`Request failed: ${response.status}`);
          return response.text();
        })
        .then((text) => {
          this.setCachedHtml(cacheKey, text);
          this.applyRecommendations(text);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    }

    applyRecommendations(text) {
      const html = document.createElement("div");
      html.innerHTML = text;
      const recommendations = html.querySelector("product-recommendations");

      if (recommendations?.innerHTML.trim().length) {
        this.innerHTML = recommendations.innerHTML;
        this.hydrateDynamicContent();
      }

      if (this.classList.contains("complementary-products")) {
        this.remove();
      }

      if (html.querySelector(".grid__item")) {
        this.classList.add("product-recommendations--loaded");
      }
    }

    hydrateDynamicContent() {
      customElements.whenDefined("swiper-component").then(() => {
        this.querySelectorAll("swiper-component").forEach((swiperComponent) => {
          requestAnimationFrame(() => {
            swiperComponent.initializeSwiper?.();
          });
        });
      });

      document.dispatchEvent(new CustomEvent("product-recommendations:loaded", {
        detail: {
          sectionId: this.dataset.sectionId,
          productId: this.dataset.productId
        }
      }));
    }

    getCachedHtml(cacheKey) {
      if (!window.sessionStorage) return null;
      try {
        const cached = JSON.parse(sessionStorage.getItem(cacheKey) || "null");
        if (!cached || Date.now() - cached.time > 10 * 60 * 1000) return null;
        return cached.html;
      } catch (e) {
        return null;
      }
    }

    setCachedHtml(cacheKey, html) {
      if (!window.sessionStorage || !html) return;
      try {
        sessionStorage.setItem(cacheKey, JSON.stringify({
          time: Date.now(),
          html
        }));
      } catch (e) { /* storage can be full or unavailable */ }
    }
  }
  
  customElements.define("product-recommendations", ProductRecommendations);
}
